/**
 * @description Dynamically calculates the path to the public folder when hosted locally and all other environments.
 *  reference: https://create-react-app.dev/docs/using-the-public-folder/
 * 
 * @param {string} resourceUri excluding '/public/' any sub directory within /public 
 * @returns {string} string from the root of the public folder regardless of hosted environment.
 */
export const toPublicResource = (resourceUri) => {
    //  Guard: to avoid confusion, add a '/' if the specified uri does not already start with it.
    if(!resourceUri.startsWith('/', 0)){
        resourceUri = `/${resourceUri}`;
    }

    return `${process.env.PUBLIC_URL}${resourceUri}`;
}